import { GlobalWithTUWidgets } from '@scripts/widgets/types';

const g: GlobalWithTUWidgets = globalThis;

function setTranslations(translations: { [key: string]: string }) {
  g.TUWidgets = g.TUWidgets || {};
  g.TUWidgets.translations = translations;
}

function $t(key: string): string {
  return g.TUWidgets?.translations?.[key] || key;
}
export { $t, setTranslations };
